import React from "react";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Alert } from "antd";
import { jwtDecode } from "jwt-decode";

const MySwal = withReactContent(Swal);

// Hook personalizado para manejar alertas
// export const useAlerta = () => {
//   const [alerta, setAlerta] = React.useState(null);

//   // Temporizador para cerrar la alerta automáticamente
//   React.useEffect(() => {
//     if (alerta) {
//       const timer = setTimeout(() => setAlerta(null), 5000); // Cierra después de 5 segundos
//       return () => clearTimeout(timer); // Limpia el temporizador si el componente se desmonta o cambia la alerta
//     }
//   }, [alerta]);

//   return { alerta, setAlerta };
// };

// Función para cerrar sesión
export const logout = () => {
  window.location.href = "/login";
  localStorage.removeItem("administradoresSessionToken");
};

// Función para renovar la sesión
export const renewSession = async (setAlerta) => {
  const URI_RENEW = process.env.REACT_APP_DOMINIO + "/refrescar-token";

  try {
    const response = await axios.post(
      URI_RENEW,
      {},
      {
        withCredentials: true,
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // const decoded = jwtDecode(response.data.token)
    // console.log("response", decoded)
    if (response.status === 200) {
      localStorage.setItem("administradoresSessionToken", response.data.token);
      return true;
    } else if (response.status === 401){
      CheckExpiracion();
    }
  } catch (error) {
    
    logout();
  }
};

// Función para traer datos de un objeto
export const traerDatosObjeto = (url_api) => {
  return new Promise((res, rej) => {
    axios
      .get(url_api, {
        withCredentials: true,
        credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        res(response.data);
      })
      .catch((error) => console.error(error));
  });
};

// Función para manejar la expiración de la sesión
export const CheckExpiracion = () => {
  MySwal.fire({
    text: "Su sesión caducó",
    imageHeight: 55,
    confirmButtonText: "Ok",
    showConfirmButton: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCloseButton: false,
  }).then((result) => {
    localStorage.removeItem("administradoresSessionToken");
    window.location.href = "/login";  
  });
  
};

// Headers para autenticación
export const HeadersAuth = {
  withCredentials: true,
  credentials: "include",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
};

// Función para traer datos con manejo de errores y alertas
export const traerDatos = (url_api, setAlerta) => {
  return new Promise((res, rej) => {
    axios
      .get(url_api, {
        withCredentials: true,
        credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.code === 409) {
          CheckExpiracion();
        } else {
          res(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
        setAlerta({
          type: "error",
          message: "Ocurrió un error al cargar los datos. Intenta más tarde.",
        });
      });
  });
};